<div [formGroup]="form">

    <kal-tab-group formControlName="selectedTab">

        <kal-tab *ngFor="let control of mailsList.controls; index as i"
                 formArrayName="mailsList">

            <div [formGroupName]="i">

                <ng-template kalTabLabel>
                    <div class="kal-tab-header__label">{{ getMailParameters(i)?.label }}</div>
                    <kal-icon (click)="closeTab(i)">close</kal-icon>
                </ng-template>

                <ng-template kalTabContent>

                    <app-shared-mail formControlName="mail"
                                     [viewId]="getMailParameters(i)?.viewId"
                                     [publipostageCode]="getMailParameters(i)?.publipostageCode"
                                     [documentCodesList]="getMailParameters(i)?.documentCodesList"
                                     [documentCodesListMode]="getMailParameters(i)?.documentCodesListMode"
                                     [generatedDocumentsList]="getMailParameters(i)?.generatedDocumentsList"
                                     [kalLoading]="loading$ | async">
                    </app-shared-mail>

                    <div class="gup-C-validationArea gup-O-list">

                        <div class="gup-O-list__item">
                            <kal-button (click)="sendMail(i)"
                                        [disabled]="control.invalid || (loading$ | async)"
                                        kalTheme="primary">
                                Envoyer l'e-Mail
                            </kal-button>
                        </div>

                        <div class="gup-O-list__item">
                            <kal-button (click)="closeTab(i)"
                                        kalTheme="secondary">
                                Fermer sans envoyer
                            </kal-button>
                        </div>

                    </div>

                </ng-template>

            </div>

        </kal-tab>

    </kal-tab-group>

</div>
